import { Component, OnInit } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material';
import { EventEmitter } from 'events';

import { AuthService } from './../../../services/auth.service';
import { ChangePasswordComponent } from './../../../change-password-component/change-password.component';
import { TwoFactorsAuthenticationComponent } from './../../../two-factors-authentication-component/two-factors-authentication.component';
import { UserManageInfo } from '../../../models/userManageInfo';

declare var require: any;
const swal = require('sweetalert2');

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {

  public id: string = null;
  public ruolo: string = null;
  public newPassword: string;
  public oldPassword: string;
  public CurrentUser: UserManageInfo = new UserManageInfo();

  constructor(private router: Router, private authService: AuthService, public dialog: MatDialog) {
    this.authService.UserConnected.subscribe(result => {
      if (result != null) {
        this.CurrentUser = result;
      }
    });
  }

  public config: PerfectScrollbarConfigInterface = {};
  // This is for Notifications
  notifications: Object[] = [{
    round: 'round-danger',
    icon: 'ti-link',
    title: 'Luanch Admin',
    subject: 'Just see the my new admin!',
    time: '9:30 AM'
  }, {
    round: 'round-success',
    icon: 'ti-calendar',
    title: 'Event today',
    subject: 'Just a reminder that you have event',
    time: '9:10 AM'
  }, {
    round: 'round-info',
    icon: 'ti-settings',
    title: 'Settings',
    subject: 'You can customize this template as you want',
    time: '9:08 AM'
  }, {
    round: 'round-primary',
    icon: 'ti-user',
    title: 'Pavan kumar',
    subject: 'Just see the my admin!',
    time: '9:00 AM'
  }];

  // This is for Mymessages
  mymessages: Object[] = [{
    useravatar: 'src/assets/images/users/1.jpg',
    status: 'online',
    from: 'Pavan kumar',
    subject: 'Just see the my admin!',
    time: '9:30 AM'
  }, {
    useravatar: 'src/assets/images/users/2.jpg',
    status: 'busy',
    from: 'Sonu Nigam',
    subject: 'I have sung a song! See you at',
    time: '9:10 AM'
  }, {
    useravatar: 'src/assets/images/users/2.jpg',
    status: 'away',
    from: 'Arijit Sinh',
    subject: 'I am a singer!',
    time: '9:08 AM'
  }, {
    useravatar: 'src/assets/images/users/4.jpg',
    status: 'offline',
    from: 'Pavan kumar',
    subject: 'Just see the my admin!',
    time: '9:00 AM'
  }];

  logout() {
    this.authService.logout()
      .subscribe(result => {
        console.log(result);
      })
  }

  navigateToProfile() {
    this.router.navigate(['/profile']);
  }

  navigateSettings() {
    this.router.navigate(['/settings']);
  }

  openDialogChangePassword(id: any, ruolo: string): void {
    console.log("openDialog");
    let dialogRef = this.dialog.open(ChangePasswordComponent, {
      data: {
        id,
        ruolo
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null)
        console.log("afterClosed", result);
    });
  }

  openDialogEnableTwoFactorAuth(id: any, ruolo: string): void {
    console.log("openDialog");
    let dialogRef = this.dialog.open(TwoFactorsAuthenticationComponent, {
      data: {
        id,
        ruolo
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null)
        console.log("afterClosed", result);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full/header/header.component.ts